import { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const TenantContext = createContext(null);

export function TenantProvider({ children }) {
  const [tenant, setTenant] = useState(null);
  const [tenantReady, setTenantReady] = useState(false);

  /* eslint-disable */
  useEffect(() => {
    const resolveSlug = () => {
      const cookieEntry = document.cookie.split('; ').find(row => row.startsWith('sivarsend_tenant='));
      if (cookieEntry) {
        try {
          const parsed = JSON.parse(decodeURIComponent(cookieEntry.slice('sivarsend_tenant='.length)));
          if (parsed.slug) return parsed.slug;
        } catch {}
      }
      const hostname = window.location.hostname;
      const parts = hostname.split('.');
      return parts.length >= 3 ? parts[0] : 'maxienvios';
    };

    const slug = resolveSlug();
    console.log('[TenantContext] resolving full row for slug:', slug);

    supabase
      .from('tenants')
      .select('id, slug, company_name, logo_url, plan_tier, features, tenant_type')
      .eq('slug', slug)
      .eq('is_active', true)
      .maybeSingle()
      .then(({ data, error }) => {
        if (data && !error) {
          console.log('[TenantContext] resolved full tenant:', data.slug, data.company_name);
          setTenant(data);
        } else {
          console.warn('[TenantContext] tenant lookup failed:', error?.message);
        }
        setTenantReady(true);
      });
  }, []);
  /* eslint-enable */

  return (
    <TenantContext.Provider value={{ tenant, tenantReady }}>
      {children}
    </TenantContext.Provider>
  );
}

export const useTenant = () => useContext(TenantContext);

// Se dispara una sola vez por sesión — si la columna falta, el aviso sirve una
// vez, no en cada render.
let tenantTypeWarned = false;

// 'agency' | 'viajero' mientras el tenant esté resuelto; null mientras carga.
// Nunca lanza: seguro de llamar incluso fuera de <TenantProvider>.
export function useTenantType() {
  const ctx = useTenant();
  const tenant = ctx?.tenant ?? null;

  if (!tenant) return null;

  if (tenant.tenant_type === undefined) {
    if (!tenantTypeWarned) {
      tenantTypeWarned = true;
      console.warn('[TenantContext] tenant_type missing on tenant', tenant?.slug);
    }
    return null;
  }

  return tenant.tenant_type ?? null;
}

// Booleano. False mientras carga, false si falta la columna. Nunca null.
export function useIsViajeroTenant() {
  const type = useTenantType();
  if (type === undefined || type === null) return false;
  return type === 'viajero';
}

// Booleano. False mientras carga, false si falta la columna. Nunca null.
export function useIsAgencyTenant() {
  const type = useTenantType();
  if (type === undefined || type === null) return false;
  return type === 'agency';
}
